import React from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";

import { DownloadCSV } from "../../../templates/teacher/DownloadCSV";
import {
  Context,
  fetchSimpleTeachingMaterials,
  fetchDataDownloadCSV,
  notFoundPath,
  classDataPath,
} from "../../../teacherStore";
import { IQuestion } from "../../../state";

export default () => {
  const [dataCSV, setDataCSV] = React.useState<string[][]>([]);
  const { state, dispatch } = React.useContext(Context);
  const params = useParams<{
    class_id: string;
  }>();
  const class_id = parseInt(params.class_id);

  React.useEffect(() => {
    dispatch(fetchSimpleTeachingMaterials(class_id));
  }, [class_id, dispatch]);

  const handleDownloadCSV = (teachingMaterialID: number, LessonID: number) => {
    dispatch(fetchDataDownloadCSV(LessonID, class_id, teachingMaterialID));
  };
  const { state: locationState } = useLocation<{
    nameClass: string;
  }>();
  const history = useHistory();
  const nameClass = locationState?.nameClass;

  React.useEffect(() => {
    if (!nameClass) {
      history.replace(notFoundPath);
    }
  }, [history, nameClass]);

  const links = React.useMemo(
    () => [
      {
        name: `クラスデータ`,
        to: classDataPath,
      },
      {
        name: nameClass ?? "",
        to: `${classDataPath}/${class_id}`,
        state: { nameClass },
      },
      {
        name: "回答データのダウンロード",
        to: "#",
      },
    ],
    [nameClass, class_id],
  );

  const goBack = React.useCallback(
    () =>
      history.push(`${classDataPath}/${class_id}`, {
        nameClass,
      }),
    [class_id, history, nameClass],
  );

  React.useEffect(() => {
    if (state.lessonCSV) {
      setDataCSV([]);
      const stateDataCSV: any[] = [];
      const listQuestions = state.lessonCSV!.questions.filter(
        (question: IQuestion, index: number, self: any) =>
          index ===
          self.findIndex(
            (q: any) =>
              q.issue_id === question.issue_id &&
              q.issue_page === question.issue_page,
          ),
      );

      state.lessonCSV!.answers.forEach(answer => {
        const { statements, contents } = answer.contents?.reduce(
          (
            accumulate: { statements: string; contents: string },
            answerContent,
            index,
          ) => ({
            statements: !index
              ? answerContent.statement
              : `${accumulate.statements}/${answerContent.statement}`,
            contents: !index
              ? answerContent.content
              : `${accumulate.contents}/${answerContent.content}`,
          }),
          { statements: "", contents: "" },
        ) ?? { statements: "", contents: "" };

        stateDataCSV.push(
          [
            listQuestions.filter(
              question => question.issue_id === answer.issue_id,
            )[0].issue_page,
            answer.student_name,
            answer.student_id,
            answer.section,
            statements,
            contents,
            answer.updated_at,
            answer.student_group,
            answer.like_num,
            answer.comment_num,
            answer.comment_content,
          ].map(value =>
            typeof value === "string" ? value.replaceAll('"', '""') : value,
          ),
        );
      });

      const dataTitleCSV = [
        ["学校コード", state.lessonCSV!.school_code],
        ["クラス名", state.lessonCSV!.class_name],
        [
          "学校名",
          `${state.lessonCSV!.school_name_kana} ${
            state.lessonCSV!.school_name
          }`,
        ],
        [
          "教材名",
          `${state.lessonCSV!.teaching_material_name} ${
            state.lessonCSV!.teaching_material_title
          }`,
        ],
        ["Lesson", state.lessonCSV!.title],
        ["", ""],
        [
          "ページ番号",
          "生徒の名前",
          "出席番号/ID",
          "問題番号",
          "問い",
          "回答",
          "回答時刻",
          "グループ",
          "いいねの数",
          "コメントの数",
          "コメントの内容",
        ],
      ];

      setDataCSV([...dataTitleCSV, ...stateDataCSV]);
    }
  }, [state.lessonCSV]);

  return nameClass ? (
    <DownloadCSV
      links={links}
      teaching_materials={state.simple_teaching_materials}
      nameClass={nameClass}
      onDownLoadData={handleDownloadCSV}
      goBack={goBack}
      dataCSV={dataCSV}
    />
  ) : null;
};
